// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/general-operating-prohibitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/general-operating-prohibitions/general-operating-prohibitions.js';

mount([g0]);
